import type { ReadonlyVariableResource } from "./ReadonlyVariableResource";
export * from "./ReadonlyVariableResource";

export type { ReadonlyVariableResource };
